<div class="grid-row grid-gap-1">
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
    <legend class="usa-legend usa-legend--medium">Agency Information</legend>
  </div>
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
    <label class="usa-label text-bold">Customer :</label>
    <label class="usa-label">{{shipperInfo ? shipperInfo.firstName : ''}} {{shipperInfo ? shipperInfo.lastName : '' }}</label>
  </div>
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
    <label class="usa-label text-bold">Agency : </label>
    <label class="usa-label">{{ agencyInfo ? agencyInfo.agencyBureauName : ''}}</label>
  </div>
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
    <label class="usa-label text-bold">Phone : </label>
    <label class="usa-label">{{shipperInfo ? shipperInfo.phone : '' }}</label>
  </div>
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
    <label class="usa-label text-bold">Email :</label>
    <label class="usa-label">{{shipperInfo ? shipperInfo.email : '' }}</label>
  </div>
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
    <label for="contractPurchaseOrder" class="usa-label text-bold">Contract Purchase Order No./Other Authority</label>
    <button id="contractPurchaseOrder" type="button" class="usa-button" (click)="purchaseOrderModal.show()">View Purchase Orders</button>
  </div>
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
    <label for="agencyShipmentId" class="usa-label text-bold">Agency Shipment ID : </label>
    <label id="agencyShipmentId" class="usa-label">{{shipmentDetailsInfo.agencyShipmentIdNo}}</label>
  </div>
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
    <label for="lastName" class="usa-label text-bold">Agency Location Code : </label>
    <label id="lastName" class="usa-label">{{shipmentDetailsInfo.agencyLocationCode}}</label>
  </div>
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
    <legend class="usa-legend usa-legend--medium">TSP Information</legend>
  </div>
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
    <label for="Name" class="usa-label text-bold">Name : </label>
    <label id="Name" class="usa-label">{{carrier ? carrier.scacName : ''}}</label>
  </div>
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
    <label for="SCAC" class="usa-label text-bold">SCAC : </label>
    <label id="SCAC" class="usa-label">{{carrier ? carrier.scac : ''}}</label>
  </div>
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
    <label for="DUNSBradStreetName" class="usa-label text-bold">DUNS & BradStreet Number : </label>
    <label id="DUNSBradStreetName" class="usa-label">{{carrier ? carrier.dunsNumber : ''}}</label>
  </div>
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
    <label for="email" class="usa-label text-bold">
      Email :
    </label>
    <label id="email" class="usa-label">{{carrierOrganizationInfo? carrierOrganizationInfo.email : ''}}</label>
  </div>
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
    <label for="phone" class="usa-label text-bold">Phone : </label>
    <label id="phone" class="usa-label">{{carrierOrganizationInfo? carrierOrganizationInfo.phone : ''}}</label>
  </div>
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
    <label for="phoneExt" class="usa-label text-bold">Phone Ext : </label>
    <label id="phoneExt" class="usa-label">{{carrierOrganizationInfo? carrierOrganizationInfo.phoneExtension : ''}}</label>
  </div>
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
    <legend class="usa-legend usa-legend--medium">Shipment Information : </legend>
  </div>
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
    <label for="sealnumber" class="usa-label text-bold">Seal Number : </label>
    <button id="sealnumber" type="button" class="usa-button" (click)="sealNoModal.show()">View seal numbers</button>
  </div>
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
    <label for="lengthCubeOrdered" class="usa-label text-bold">Length/Cube/Equipment Ordered : </label>
    <label id="lengthCubeOrdered" class="usa-label">{{shipmentDetailsInfo.equipmentQuantity}}</label>
  </div>
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
    <label for="mode" class="usa-label text-bold">Mode : </label>
    <label id="mode" class="usa--label">{{shipmentDetailsInfo.shipmentMode}}</label>
  </div>
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
    <label for="tspProBillNo" class="usa-label text-bold">TSP Pro Bill No. : </label>
    <label id="tspProBillNo" class="usa-label">{{shipmentDetailsInfo.tspProBillNo}}</label>
  </div>
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
    <label for="pickupMoveDate" class="usa-label text-bold"> Pickup/Move Date & Time : </label>
    <label id="pickupMoveDate" class="usa-label">{{shipmentsInfo.moveDate | date:'MM/dd/yyyy, h:mm:ss a'}}</label>
  </div>
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
    <label for="requiredDeliveryDate" class="usa-label text-bold">Required Delivery Date & Time : </label>
    <label id="requiredDeliveryDate" class="usa-label">{{shipmentsInfo.requiredDeliveryDate | date:'MM/dd/yyyy, h:mm:ss a'}}</label>
  </div>
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
    <label for="selectBtn2" class="usa-label text-bold">Verify origin, destination & other addresses:</label>
    <button id="selectBtn2" type="button" (click)="openAddressVerfiicationDialog()" class="usa-button">Addresses</button>
  </div>
</div>

<div bsModal #sealNoModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="view-sealNumber" [config]="{backdrop: 'static'}">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title p-0">Seal Numbers</h4>
        <div class="close pull-right" aria-label="Close" (click)="sealNoModal.hide()">
          <span aria-hidden="true">&times;</span>
        </div>
      </div>
      <div class="modal-body">
        @for (item of sealNos; track item) {
          <ul>
            <li> {{item.sealNumber}} </li>
          </ul>
        }
      </div>
    </div>
  </div>
</div>

<div bsModal #purchaseOrderModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="view-purchaseOrder" [config]="{backdrop: 'static'}">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title p-0">Purchase/Contract Orders</h4>
        <div class="close pull-right" aria-label="Close" (click)="purchaseOrderModal.hide()">
          <span aria-hidden="true">&times;</span>
        </div>
      </div>
      <div class="modal-body">
        @for (item of purchaseOrders; track item) {
          <ul>
            <li> {{item.purchaseOrderNumber}} </li>
          </ul>
        }
      </div>
    </div>
  </div>
</div>
